import { LabelModule } from '@progress/kendo-angular-label';
import { NgModule } from '@angular/core';
import { DocumentComponent } from './document.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { SendEmailModule } from '../shared/send-document/send-document.module';
import { DocumentViewerModule } from '../shared/document-viewer/document-viewer.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DocumentLinkSelectionComponent } from './document-link-selection/document-link-selection.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { DocumentLinkUploadComponent } from './document-link-upload/document-link-upload.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotFoundModule } from '../shared/not-found/not-found.module';
import { WebcamModule } from 'ngx-webcam';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { DocumentLinkConsentComponent } from './document-link-consent/document-link-consent.component';
import { FormlyModule } from '@ngx-formly/core';
import { SignaturePadModule } from '../shared/signature-pad/signature-pad.module';
import { NgxPrintModule } from 'ngx-print';

@NgModule({
  declarations: [DocumentComponent, DocumentLinkSelectionComponent, DocumentLinkUploadComponent, DocumentLinkConsentComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    InputsModule,
    LabelModule,
    DialogsModule,
    GridModule,
    ButtonsModule,
    NgxJsonViewerModule,
    SendEmailModule,
    DocumentViewerModule,
    PipesModule,
    DropDownsModule,
    NotFoundModule,
    WebcamModule,
    ProgressBarModule,
    FormlyModule,
    SignaturePadModule,
    NgxPrintModule
  ],
  exports: [
    DocumentComponent
  ]
})
export class DocumentModule { }
